var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: _vm.loads.length || _vm.loadingBookedLoads } },
    [
      !_vm.appLoading && !_vm.loadingBookedLoads && !_vm.loads.length
        ? _c(
            "v-flex",
            [
              _c("empty-state", {
                attrs: {
                  message: "You don't have any " + _vm.statusName + " loads."
                }
              })
            ],
            1
          )
        : [
            _vm.isMobile
              ? _c(
                  "div",
                  [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "py-0" },
                          [
                            _c("v-layout", { attrs: { column: "" } }, [
                              _c("label", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.loadsAccurateSince) +
                                    "\n              "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  fab: "",
                                  small: "",
                                  flat: "",
                                  right: "",
                                  color: "accent"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("refresh")
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("refresh")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.loads, function(load) {
                      return _c(
                        "v-card",
                        { key: load.id, staticClass: "xs12 my-2" },
                        [
                          _c(
                            "v-card-title",
                            [
                              _c("v-layout", { attrs: { column: "" } }, [
                                _c("h6", { staticClass: "title" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(load.humanId) +
                                      "\n              "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { block: "", color: "accent" },
                                  on: {
                                    click: function($event) {
                                      return _vm.viewLoadDetail(load)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { size: "18", color: "white" } },
                                    [_vm._v("visibility")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "pl-2" }, [
                                    _vm._v("View Load")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _c("b", [_vm._v("From:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("originName")(_vm.loadDetails(load))
                                  )
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("b", [_vm._v("To:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("destinationName")(
                                      _vm.loadDetails(load)
                                    )
                                  )
                              ),
                              _c("br"),
                              _c("br"),
                              _vm._v(" "),
                              _c("p", [
                                _c("b", [_vm._v("Pickup Time:")]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.loadModel.notificationPickupTime(load)
                                        .value
                                    ) +
                                    "\n              "
                                ),
                                _vm.status === _vm.loadStatus.SCHEDULED
                                  ? _c("span", { staticClass: "font-italic" }, [
                                      _vm._v(
                                        "\n            (" +
                                          _vm._s(
                                            _vm.loadModel.notificationPickupTime(
                                              load
                                            ).providedBy
                                          ) +
                                          ")\n          "
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.loadModel.notificationDeliveryTime(
                                              load
                                            ).value
                                          ) +
                                          "\n          "
                                      )
                                    ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                [
                                  _c("load-distance", {
                                    attrs: { "load-details": load }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", [
                                _c("b", [_vm._v("Carrier:")]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.bookedLoadHaulingCompany(load).name
                                    ) +
                                    "\n              "
                                ),
                                _vm.driverId(load)
                                  ? _c("span", { staticClass: "font-italic" }, [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.driverName(load)) +
                                          "\n          "
                                      )
                                    ])
                                  : _c("span", { staticClass: "font-italic" }, [
                                      _vm._v("(no driver assigned)")
                                    ])
                              ]),
                              _vm._v(" "),
                              _c("v-select-load-driver", {
                                attrs: { load: load, company: _vm.company },
                                on: {
                                  refresh: function($event) {
                                    return _vm.$emit("updateLoad", $event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.loadModel.requiresWashout(load)
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "icon-base",
                                        {
                                          attrs: {
                                            width: "25",
                                            height: "25",
                                            "icon-color": "#352208",
                                            "icon-name": "hose"
                                          }
                                        },
                                        [_c("icon-hose")],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.loadModel.requireWoodChips(load)
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "icon-base",
                                        {
                                          attrs: {
                                            width: "25",
                                            height: "25",
                                            "icon-color": "#352208",
                                            viewBox: "0 0 5 5",
                                            "icon-name": "wood"
                                          }
                                        },
                                        [_c("icon-wood")],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.loadModel.requireWeatherboards(load)
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "icon-base",
                                        {
                                          attrs: {
                                            width: "25",
                                            height: "25",
                                            "icon-name": "cold",
                                            "icon-color": "#352208"
                                          }
                                        },
                                        [_c("icon-cold")],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : [
                  _c(
                    "v-container",
                    { staticClass: "pa-0", attrs: { fluid: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: !_vm.isMobile, column: _vm.isMobile } },
                        [
                          (_vm.isMobile
                          ? !_vm.selectedLoad
                          : true)
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", md3: "" } },
                                [
                                  _c(
                                    "v-load-nav-list",
                                    {
                                      attrs: {
                                        "search-prompt":
                                          "Search " + _vm.statusName + " loads",
                                        title:
                                          _vm.statusName +
                                          " (" +
                                          _vm.loads.length +
                                          ")",
                                        "accurate-since":
                                          _vm.loadsAccurateSince,
                                        loads: _vm.filteredLoads,
                                        customerLoads:
                                          _vm.groupedBySponsorLoads,
                                        carrierLoads: _vm.groupedByCarrierLoads,
                                        loading: _vm.loadingBookedLoads,
                                        history: false
                                      },
                                      on: {
                                        "update:searchTerm": function($event) {
                                          _vm.search = $event
                                        },
                                        refresh: _vm.refreshBookedLoads
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "loadTile",
                                            fn: function(ref) {
                                              var idx = ref.idx
                                              var load = ref.load
                                              return [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    key:
                                                      "unassigned_load_" +
                                                      idx +
                                                      "_" +
                                                      load.listingHumanId,
                                                    class: [
                                                      {
                                                        "primary lighten-1": _vm.isSelectedLoad(
                                                          load
                                                        )
                                                      },
                                                      _vm.loadStyleClass(load)
                                                    ],
                                                    attrs: {
                                                      inactive: _vm.isSelectedLoad(
                                                        load
                                                      ),
                                                      ripple: "",
                                                      avatar: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.selectLoad(
                                                          load
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.loadModel.loadNickname(
                                                                  load
                                                                ) ||
                                                                  _vm._.get(
                                                                    load,
                                                                    "sponsor.name",
                                                                    "..."
                                                                  )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          {
                                                            staticClass:
                                                              "text--primary"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  load.humanId
                                                                ) +
                                                                ": " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatDay"
                                                                  )(
                                                                    load.pickupTime
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-sub-title",
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.bookedLoadHaulingCompany(
                                                                    load
                                                                  ).name
                                                                )
                                                            ),
                                                            load.tacticalInfo
                                                              .assignedTruckingCompanyDriverName
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ", " +
                                                                      _vm._s(
                                                                        load
                                                                          .tacticalInfo
                                                                          .assignedTruckingCompanyDriverName
                                                                      )
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider", {
                                                  key:
                                                    "unassigned_divider_" +
                                                    idx +
                                                    "_" +
                                                    load.listingHumanId
                                                })
                                              ]
                                            }
                                          },
                                          {
                                            key: "customerLoadsTile",
                                            fn: function(ref) {
                                              var idx = ref.idx
                                              var loads = ref.loads
                                              var sponsor = ref.sponsor
                                              return [
                                                _c(
                                                  "v-list-group",
                                                  { key: "groupedBy_" + idx },
                                                  [
                                                    _c(
                                                      "v-list-tile",
                                                      {
                                                        attrs: {
                                                          slot: "activator"
                                                        },
                                                        slot: "activator"
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-tile-action",
                                                          [
                                                            _c(
                                                              "v-chip",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "green",
                                                                  "text-color":
                                                                    "white",
                                                                  small: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      loads.length
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(sponsor)
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(loads, function(
                                                      load
                                                    ) {
                                                      return [
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            key:
                                                              "grouped_load_" +
                                                              load.humanId,
                                                            class: {
                                                              "primary lighten-1": _vm.isSelectedLoad(
                                                                load
                                                              )
                                                            },
                                                            attrs: {
                                                              inactive: _vm.isSelectedLoad(
                                                                load
                                                              ),
                                                              ripple: "",
                                                              avatar: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.selectLoad(
                                                                  load
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _vm.loadModel.loadNickname(
                                                                  load
                                                                )
                                                                  ? _c(
                                                                      "v-list-tile-title",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.loadModel.loadNickname(
                                                                              load
                                                                            )
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-sub-title",
                                                                  {
                                                                    staticClass:
                                                                      "text--primary"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          load.humanId
                                                                        ) +
                                                                        ": " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "formatDay"
                                                                          )(
                                                                            load.pickupTime
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-sub-title",
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.bookedLoadHaulingCompany(
                                                                            load
                                                                          ).name
                                                                        )
                                                                    ),
                                                                    load
                                                                      .tacticalInfo
                                                                      .assignedTruckingCompanyDriverName
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              ", " +
                                                                                _vm._s(
                                                                                  load
                                                                                    .tacticalInfo
                                                                                    .assignedTruckingCompanyDriverName
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _vm._.get(
                                                                      load,
                                                                      "terms.customerSettlement",
                                                                      false
                                                                    )
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              ", $" +
                                                                                _vm._s(
                                                                                  load
                                                                                    .terms
                                                                                    .customerSettlement
                                                                                    .amount
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-divider", {
                                                          key:
                                                            "load_divider_" +
                                                            load.humanId
                                                        })
                                                      ]
                                                    })
                                                  ],
                                                  2
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "carrierLoadsTile",
                                            fn: function(ref) {
                                              var idx = ref.idx
                                              var loads = ref.loads
                                              var carrier = ref.carrier
                                              return [
                                                _c(
                                                  "v-list-group",
                                                  { key: "groupedBy_" + idx },
                                                  [
                                                    _c(
                                                      "v-list-tile",
                                                      {
                                                        attrs: {
                                                          slot: "activator"
                                                        },
                                                        slot: "activator"
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-tile-action",
                                                          [
                                                            _c(
                                                              "v-chip",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "accent",
                                                                  "text-color":
                                                                    "white",
                                                                  small: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      loads.length
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-title",
                                                          [
                                                            _vm._v(
                                                              _vm._s(carrier)
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(loads, function(
                                                      load
                                                    ) {
                                                      return [
                                                        _c(
                                                          "v-list-tile",
                                                          {
                                                            key:
                                                              "grouped_load_" +
                                                              load.humanId,
                                                            class: {
                                                              "primary lighten-1": _vm.isSelectedLoad(
                                                                load
                                                              )
                                                            },
                                                            attrs: {
                                                              inactive: _vm.isSelectedLoad(
                                                                load
                                                              ),
                                                              ripple: "",
                                                              avatar: ""
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.selectLoad(
                                                                  load
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _vm.loadModel.loadNickname(
                                                                  load
                                                                )
                                                                  ? _c(
                                                                      "v-list-tile-title",
                                                                      [
                                                                        _vm._v(
                                                                          "\n                            " +
                                                                            _vm._s(
                                                                              _vm.loadModel.loadNickname(
                                                                                load
                                                                              )
                                                                            ) +
                                                                            "\n                          "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-sub-title",
                                                                  {
                                                                    staticClass:
                                                                      "text--primary"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          load.humanId
                                                                        ) +
                                                                        ": " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "formatDay"
                                                                          )(
                                                                            load.pickupTime
                                                                          )
                                                                        ) +
                                                                        "\n                          "
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-sub-title",
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          _vm.loadModel.loadNickname(
                                                                            load
                                                                          ) ||
                                                                            load
                                                                              .sponsor
                                                                              .name
                                                                        ) +
                                                                        "\n                            "
                                                                    ),
                                                                    load
                                                                      .tacticalInfo
                                                                      .assignedTruckingCompanyDriverName
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              ", " +
                                                                                _vm._s(
                                                                                  load
                                                                                    .tacticalInfo
                                                                                    .assignedTruckingCompanyDriverName
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _vm._.get(
                                                                      load,
                                                                      "terms.customerSettlement",
                                                                      false
                                                                    )
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              ", $" +
                                                                                _vm._s(
                                                                                  load
                                                                                    .terms
                                                                                    .customerSettlement
                                                                                    .amount
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-divider", {
                                                          key:
                                                            "load_divider_" +
                                                            load.humanId
                                                        })
                                                      ]
                                                    })
                                                  ],
                                                  2
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1037358495
                                      )
                                    },
                                    [
                                      _c(
                                        "template",
                                        { slot: "subheader" },
                                        [
                                          _c(
                                            "v-subheader",
                                            {
                                              staticClass: "sort-btn",
                                              on: {
                                                click: function($event) {
                                                  return _vm.toggleSort()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pr-2",
                                                  attrs: { color: "primary" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.status ===
                                                          _vm.loadStatus
                                                            .SCHEDULED
                                                          ? "arrow_upward"
                                                          : "play_for_work"
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.status ===
                                              _vm.loadStatus.SCHEDULED
                                                ? _c("span", [
                                                    _vm._v("Pickup Time")
                                                  ])
                                                : _c("span", [
                                                    _vm._v("Delivery Time")
                                                  ]),
                                              _vm._v(" "),
                                              _c("v-spacer"),
                                              _vm._v(" "),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "pl-3",
                                                  attrs: { color: "accent" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      event\n                    "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.sortDesc
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "accent" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      arrow_drop_down\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "accent" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      arrow_drop_up\n                    "
                                                      )
                                                    ]
                                                  )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isMobile || _vm.viewedLoad
                            ? _c(
                                "v-flex",
                                { attrs: { md9: "" } },
                                [
                                  _vm.selectedLoad
                                    ? _c("load-detail", {
                                        staticClass: "pl-2",
                                        attrs: {
                                          currentLoad: _vm.selectedLoad,
                                          company: _vm.company,
                                          loading: _vm.loadingLoad
                                        },
                                        on: {
                                          removeLoad: function($event) {
                                            return _vm.removeLoad($event)
                                          },
                                          updateLoad: function($event) {
                                            return _vm.$emit(
                                              "updateLoad",
                                              $event
                                            )
                                          },
                                          refreshLoad: function($event) {
                                            return _vm.refreshSelectedLoad()
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ff114bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff114bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/ScheduledLoads.vue
// module id = null
// module chunks = 